// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__3gq8U","load3":"Spinner_load3__11qyD","ThemeLight":"Spinner_ThemeLight__1fEZA"};